import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './client';

/**
 * Builds the app's QueryClient.
 *
 * A factory, not a module-level singleton: tests need a fresh cache per test, and
 * a shared instance would leak data between them.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 4xx responses are not transient — retrying them just delays the error.
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status < 500) {
            return false;
          }

          return failureCount < 2;
        },
        // Data is considered fresh for 30s, so navigating back to a screen does
        // not refetch immediately.
        staleTime: 30_000,
      },
    },
  });
}
